import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";
import { isFrontendRouteBlocked } from "@/config/routeMapping";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to, from, next) => {
    // Verificar autenticação
    if (to.name !== "auth" && to.name !== "reset-password" && to.name !== "verify-email" && (!store.state.auth.user || !store.state.auth.token)) {
        next({ name: "auth" });
        return;
    }
    
    // Verificar se rota requer SysAdmin
    if (to.meta?.requiresSysAdmin) {
        const isSysAdmin = store.getters['auth/isSysAdmin'];
        if (!isSysAdmin) {
            // Redirecionar para home se não for SysAdmin
            next({ name: "home" });
            return;
        }
    }
    
    // Verificar se rota está bloqueada pelo perfil de acesso
    if (to.path && to.name !== "auth" && to.name !== "reset-password" && to.name !== "verify-email") {
        const blockedRoutes = store.getters['auth/blockedRoutes'];
        
        if (blockedRoutes && blockedRoutes.length > 0) {
            const isBlocked = isFrontendRouteBlocked(to.path, blockedRoutes);
            
            if (isBlocked) {
                // Emitir evento para mostrar modal de upgrade
                if (window.EventBus) {
                    setTimeout(() => {
                        window.EventBus.$emit('show-upgrade-modal', {
                            feature: to.meta?.featureName || 'Esta funcionalidade',
                            route: to.path
                        });
                    }, 2000);
                }
                
                // Redirecionar para home
                next({ name: "schedule" });
                return;
            }
        }
    }
    
    next();
});

export default router;
